module.exports = __webpack_public_path__ + "img/thermometer.22d75090.svg";